import { Skeleton } from "@commonlibs";
import { Fragment } from "react";
import NothingToShow from "../../feedback/NothingToShow/NothingToShow";
import Group from "../Group/Group";
import { SimpleListProps } from "./SimpleList.types";
import getFinalRenderListFunction from "./utils/getFinalRenderListFunction";

function SimpleList<T>({
    children,
    data,
    Skeleton: SkeletonProp = Skeleton,
    numberOfSketelons = 3,
    renderItem,
    isLoading,
    nothingToShow,
}: SimpleListProps<T>): JSX.Element {
    const hasItems = isLoading || (data?.length ?? 0) > 0;
    //Get the render function, it can be a renderItem fn as prop or a children function
    const finalRenderItem = getFinalRenderListFunction({ children, renderItem });
    const isChildrenElement = typeof children !== "undefined" && !finalRenderItem;

    return hasItems ? (
        <>
            {finalRenderItem &&
                data?.map((item, i) => (
                    <Fragment
                        // skipcq
                        key={i}
                    >
                        {finalRenderItem?.(item, i)}
                    </Fragment>
                ))}
            {isLoading && <Group Component={SkeletonProp} count={numberOfSketelons} />}
        </>
    ) : (
        <>{isChildrenElement ? children : nothingToShow ?? <NothingToShow />}</>
    );
}

export default SimpleList;
